import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// import { actionCreators as modalActions } from '~redux/Modal/actions';
// import { MODAL_TARGET } from '~redux/Modal/constants';
import closeIcon from '~assets/ic_general_close.svg';

import styles from './styles.module.scss';

interface Props {
  isOpen: boolean;
  closeModal: Function;
  className?: string;
  title?: string;
  children: any;
}

class Modal extends Component<Props> {
  handleCloseModal = () => this.props.closeModal();

  targetRef = React.createRef();

  targetElement: any = null;

  componentDidMount() {
    this.targetElement = this.targetRef.current;
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  render() {
    const { isOpen, className, title, children } = this.props;

    isOpen ? disableBodyScroll(this.targetElement) : enableBodyScroll(this.targetElement);

    return (
      ReactDOM.createPortal(
        <div className={cx({[styles.visible]: isOpen},`row middle center full-width ${styles.backDropModal}`)}>
          <div
            className={cx(
              `column ${styles.modalContent}`,
              {
                [styles.modalOpened]: isOpen
              },
              className
            )}
          >
            <div className={`row middle space-between ${styles.containerTitle}`}>
              <h3 className={`m-right-2 ${styles.title}`}>{title}</h3>
              <button type="button" onClick={this.handleCloseModal}>
                <img className={styles.iconClose} src={closeIcon} alt="" />
              </button>
            </div>
            {children}
          </div>
        </div>,
        document.body
      )
    );
  }
}

// const mapStateToProps = state => ({
//   isOpen: state.modal[MODAL_TARGET]
// });
//
// const mapDispatchToProps = dispatch => ({
//   closeModal: () => dispatch(modalActions.closeModal())
// });

export default Modal;
